/* eslint-disable */
// @ts-nocheck
const isGainsightPxInitialized = () => !!window?.aptrinsic;

export const initGainsightPx = tagKey => {
    if (isGainsightPxInitialized()) {
        return false;
    }

    // Gainsight PX initialization script
    // https://support.gainsight.com/PX/API_for_Developers/01About/Track_your_Users_and_Accounts
    (function (n, t, a, e, co) {
        var i = 'aptrinsic';
        (n[i] =
            n[i] ||
            function () {
                (n[i].q = n[i].q || []).push(arguments);
            }),
            (n[i].p = e);
        n[i].c = co;
        var r = t.createElement('script');
        (r.async = !0), (r.src = a + '?a=' + e);
        var c = t.getElementsByTagName('script')[0];
        c.parentNode.insertBefore(r, c);
    })(window, document, 'https://web-sdk.aptrinsic.com/api/aptrinsic.js', tagKey);

    return true;
};

export const identifyUserToGainsight = ({
    userId,
    primaryEmail,
    firstName = '',
    lastName = '',
    accountId,
    eventName,
}) => {
    if (isGainsightPxInitialized()) {
        aptrinsic(
            'identify',
            {
                // User Fields
                id: userId, // Required for logged in app users
                email: primaryEmail,
                firstName,
                lastName,
            },
            {
                // Account Fields
                id: accountId, // Required
                name: eventName, // TODO: is it ok to use eventName as accountName?
            }
        );
    }
};
